import { Dispatch, FC, FormEvent, SetStateAction, useRef, useState } from "react";
import {
  BaseInput,
  BaseInputGroup,
  BaseStaticSelect,
  BaseTextArea,
  DateAndTime,
} from "../input/CustomInputs";
import { OrderForm } from "@/interface/formInterface";
import { currencies } from "@/utils/variables";
import AutocompleteLocation from "@/taxi-dispatch/dispatch/components/AutocompleteLocation";
import { Location } from "@/interface/dataInterface";
import { taxiStatusItems } from "@/constants/status";

interface Props {
  formProp: OrderForm;
  setFormProp: Dispatch<SetStateAction<OrderForm>>;
  location: Location;
  setLocation: Dispatch<SetStateAction<Location>>;
  dropoff: Location;
  setDropoff: Dispatch<SetStateAction<Location>>; 
}

const OrderFormTaxiCommon: FC<Props> = ({ formProp, setFormProp, location, setLocation, dropoff, setDropoff }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const dropoffRef = useRef<HTMLInputElement>(null);

  return (
    <div className="grid grid-cols-2 gap-4">
      <AutocompleteLocation
        placeholder="Enter pickup location"
        location={setLocation}
        inputRef={inputRef}
        selectedLocation={location.text ? location : undefined}
        onChange={(e: FormEvent<HTMLInputElement>) => {
          if (!e.currentTarget.value) setLocation({
            text: "", lat: 0, lng: 0
          })
        }}
      />
      <AutocompleteLocation 
        placeholder="Enter dropoff location"
        location={setDropoff}
        inputRef={dropoffRef}
        required={false}
        selectedLocation={dropoff.text ? dropoff : undefined}
        onChange={(e: FormEvent<HTMLInputElement>) => {
          if (!e.currentTarget.value) setDropoff({
            text: "", lat: 0, lng: 0
          })
        }}
      />
      <BaseInput
        id="fullName"
        label="Full Name"
        required={false}
        placeholder="client's full name"
        value={formProp.fullName}
        setProp={setFormProp}
      />
      <BaseInput
        id="email"
        label="Email"
        required={false}
        value={formProp.email}
        setProp={setFormProp}
      />
      <BaseInput
        id="client_phone"
        label="Phone number"
        required={false}
        value={formProp.client_phone}
        setProp={setFormProp}
        placeholder="client's phone number"
      />
      <DateAndTime formProp={formProp} setFormProp={setFormProp} />
      <BaseInputGroup
        id="fare"
        label="Price"
        value={formProp.fare}
        setProp={setFormProp}
        required={false}
        type="number"
      >
        <BaseStaticSelect
          id="currency"
          label=""
          value={formProp.currency}
          setValue={setFormProp}
          data={currencies}
        />
      </BaseInputGroup>
      <BaseStaticSelect
        id="status"
        label="Status"
        value={formProp.status}
        setValue={setFormProp}
        data={taxiStatusItems
          .filter((item) => item.display)
          .map((item) => {
            return { label: item.label, value: item.status };
          })}
      />
      <div className="sm:col-span-2">
        <BaseTextArea
          id="notes"
          label="Notes"
          value={formProp.notes}
          setProp={setFormProp}
        />
      </div>
    </div>
  );
};

export default OrderFormTaxiCommon;
